export const APP_ROOT = '/';

export const AUTH_SOCIAL_PAGE = `${APP_ROOT}auth/social/:provider`;

export const EMAIL_CONFIRM_PAGE = `${APP_ROOT}emailConfirm`;
